export default __webpack_public_path__ + "302db8bf5111724549c6500178df4e6b.svg";